export function schema_fonctions_excel() {
	return {
		title: "Paramètres",
		type: "object",
		required: ["fonctions", "code"],
		properties: {
      fonctions: [],
      functionCode: [],
      code: {
        type: "string",
      },
		},
	};
}
